import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import I18nLink from '../I18nLink';
import {
  makeSelectId,
  makeSelectPhotoNice,
  makeSelectPhoto,
} from '~/containers/PhotoPage/selectors';
import { urls } from '~/utils';

const CreatorInfo = ({ photo: { user_name, creator } }) => {
  const { nickname_for_overseas, nickname, avatar } = creator;

  if (creator.id) {
    return (
      <I18nLink
        as={`/creator-profile/${creator.id}`}
        href={{
          pathname: '/creator-profile',
          query: { creator_id: creator.id },
        }}
      >
        <a className="creator-info">
          <img
            src={urls.renderAvatarUrl(avatar)}
            className="creator-avatar"
            alt="creator-info"
          />
          <span className="link-creator-name">
            {nickname_for_overseas || nickname || user_name}
          </span>
          <style jsx>
            {`
              .creator-info {
                display: flex;
                flex-direction: row;
                align-items: center;
                background: transparent;
                color: #fff;
              }
              .creator-info .link-creator-name:hover {
                text-decoration: underline;
              }
              .creator-avatar {
                width: 25px;
                height: 25px;
                margin-right: 8px;
              }
            `}
          </style>
        </a>
      </I18nLink>
    );
  }

  return (
    <div className="creator-info">
      <img
        src={urls.renderAvatarUrl(avatar)}
        className="creator-avatar"
        alt="Creator avatar"
      />
      {nickname_for_overseas || nickname || user_name}
      <style jsx>
        {`
          .creator-info {
            display: flex;
            flex-direction: row;
            align-items: center;
            background: transparent;
            color: #fff;
          }
          .creator-info .link-creator-name:hover {
            text-decoration: underline;
          }
          .creator-avatar {
            width: 25px;
            height: 25px;
            margin-right: 8px;
          }
        `}
      </style>
    </div>
  );
};

const PhotoToolbar = ({ photo }) => {
  if (!photo) return null;

  return (
    <div className="photo-toolbar">
      <CreatorInfo photo={photo} />
      <div className="number-download">
        <FontAwesomeIcon
          icon={faDownload}
          style={{ width: '1em', marginRight: 4 }}
        />
        {photo.download_count || 0}
      </div>
      <style jsx>
        {`
          .photo-toolbar {
            position: absolute;
            opacity: 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            color: #fff;
            font-size: 16px;
            transition: 0.5s ease;
            padding: 14px;
            width: 100%;
            bottom: 0;
            background: rgba(27, 40, 51, 0.8); // GUNMETAL, #1B2833
            border-radius: 0 0 2px 2px;
            z-index: 2;
          }
          .photo-toolbar .number-download {
            display: flex;
            flex-direction: row;
            white-space: nowrap;
            align-items: center;
            margin-left: 28px;
          }
        `}
      </style>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  id: makeSelectId(),
  nice: makeSelectPhotoNice(),
  photo: makeSelectPhoto(),
});
export default connect(mapStateToProps)(PhotoToolbar);
